import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiBlobGetRequest,
} from '../../api';
import { showNotif } from '../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Kategori',
    title_pemasukan: 'Pemasukan',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Kategori',
        href: '/adm/cost-category',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_cost_category',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '100px',
        },
      },
      {
        key: 'category',
        label: 'Kategori',
      },
      {
        key: 'category_type',
        label: 'Tipe Kategori',
        sortable: true,
      },
      {
        key: 'dist_name',
        label: 'Distributor',
      },
      {
        key: 'aksi',
        label: 'Aksi',
        thStyle: {
          width: '150px',
        },
      },
    ],
    detail: false,
    form: {
      cust_code: '',
      cust_company: '',
      cust_address: '',
      cust_email: '',
      cust_phone: '',
    },
    import_form: [],
    id_distributor: '',
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeKategori(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchKategori(context, params = null) {
    let result = await ApiGetRequest(`cost-category`, params);
    return !result.error ? result.data.object : [];
  },

  async getListKategori({ commit, state }, payload = {}) {
    commit('changeKategori', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`cost-category`, params);
      commit('changeKategori', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_cost.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`cost-category`, params);
      commit('changeKategori', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailKategori({ commit, state }, payload = null) {
    commit('changeKategori', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`cost-category/${payload.id}/show`);
    commit('changeKategori', {
      loading: false,
      detail: result.error ? false : result.data.object,
      form: {
        ...data.form,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async createKategori({ commit, state, dispatch }) {
    commit('changeKategori', {
      loading: true,
    });

    let result = await ApiPostRequest(`cost-category`, state.data.form);
    commit('changeKategori', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateKategori({ commit, state, dispatch }, payload = null) {
    commit('changeKategori', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `cost-category/${payload.id}`,
      state.data.form
    );

    commit('changeKategori', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteKategori({ commit, dispatch }, payload = null) {
    commit('changeKategori', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`cost-category/${payload.id}`);
    commit('changeKategori', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
